<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>
    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Solicitudes de dinero</b-card-header>
      <b-card-body>
        <tabs fill class="flex-column flex-md-row">
          <card shadow>
            <tab-pane>
              <span slot="title">
                <i class="fa fa-fw fa-sign-in-alt"></i>Recibidas
              </span>
              <div v-if="recibidas.length > 0">
                <div
                  class="row"
                  v-for="item in recibidas"
                  @click="itemClicked(item)"
                  v-bind:key="item.EntityID"
                  style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
                >
                  <div class="col-2" style="padding-top: 10px;">
                    <img :src="item.Image" class="rounded-circle" style="width: 50px" alt />
                  </div>
                  <div class="col-4">
                    {{item.OriginAccountName}}
                    <br />
                    {{item.Reference}}
                    <br />
                    {{item.StateName}}
                  </div>
                  <div class="col-4 text-right" style="padding-top: 10px;">
                    {{item.FormattedAmount}}
                    <br />
                    {{item.FormattedDate}}
                  </div>
                </div>
                <div class="row">
                  <base-button
                    v-if="verMasRecibidas"
                    type="success"
                    size="lg"
                    @click="cargarRecibidas"                    
                    style="margin: auto; margin-top: 10px"
                  >
                    <i class="fa fa-plus fa-fw"></i>Ver más
                  </base-button>
                </div>
              </div>
              <div v-else>
                <div class="row">
                  <div class="col-12 text-center">
                    <img src="@/assets/ic_no_resultado.png" />
                  </div>
                  <div class="col-12 text-center">No se encontraron registros</div>
                </div>
              </div>
            </tab-pane>

            <tab-pane>
              <span slot="title">
                <i class="fa fa-fw fa-sign-out-alt"></i>Enviadas
              </span>
              <div v-if="enviadas.length">
                <div
                  class="row"
                  v-for="item in enviadas"
                  v-bind:key="item.EntityID"
                  style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
                >
                  <div class="col-2" style="padding-top: 10px;">
                    <img :src="item.Image" class="rounded-circle" style="width: 50px" alt />
                  </div>
                  <div class="col-4">
                    {{item.DestinyAccountName}}
                    <br />
                    {{item.Reference}}
                    <br />
                    {{item.StateName}}
                  </div>
                  <div class="col-4 text-right" style="padding-top: 10px;">
                    {{item.FormattedAmount}}
                    <br />
                    {{item.FormattedDate}}
                  </div>
                </div>
                <div class="row">
                  <base-button
                    v-if="verMasEnviadas"
                    type="success"
                    size="lg"
                    @click="cargarEnviadas"
                    style="margin: auto; margin-top: 10px"
                  >
                    <i class="fa fa-plus fa-fw"></i>Ver más
                  </base-button>
                </div>
              </div>
              <div v-else>
                <div class="row">
                  <div class="col-12 text-center">
                    <img src="@/assets/ic_no_resultado.png" />
                  </div>
                  <div class="col-12 text-center">No se encontraron registros</div>
                </div>
              </div>
            </tab-pane>
          </card>
        </tabs>
      </b-card-body>
    </b-card>

    <modal :show.sync="modal.show">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Solicitud</h5>
      </template>
      <div>
        <div class="row">
          <div class="col-md-12 text-center">
            <img :src="modal.item.Image" class="rounded-circle" style="width: 50px" alt />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <i class="fa fa-fw fa-user"></i>
            {{modal.item.OriginAccountName}}
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <i class="fa fa-fw fa-envelope"></i>
            {{modal.item.OriginAccountMail}}
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <i class="fa fa-fw fa-money-bill"></i>
            {{modal.item.FormattedAmount}}
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <i class="fa fa-fw fa-edit"></i>
            {{modal.item.Reference}}
          </div>
        </div>
        <div class="row" style="margin-top: 10px">
          <div class="col-md-12 text-center">
            <base-button type="success" size="md" @click="confirmarAceptarSolicitud">Aceptar solicitud</base-button>
            <base-button type="danger" size="md" @click="rechazarSolicitud">Rechazar solicitud</base-button>
          </div>
        </div>
        <div class="row" v-if="modal.mostrarRechazo" style="margin-top: 10px">
          <div class="col-12">
            <base-input v-model="modal.MotivoAnulacion" placeholder="Motivo anulación"></base-input>
          </div>
        </div>
        <div class="row" v-if="modal.mostrarRechazo">
          <div class="col-12 text-center">
            <base-button
              type="danger"
              size="md"
              @click="confirmarRechazarSolicitud"
            >Confirmar rechazo</base-button>
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="secondary"
          @click="modal.show = false; modal.mostrarRechazo = false"
        >Cerrar</base-button>
      </template>
    </modal>

    <pin-validation ref="pin-validation"
      :showModal.sync="showModalPinValidation"
      v-on:validPin="onValidPin"
      v-on:loadUsePaymentPin="onLoadUsePaymentPin">
    </pin-validation>
    <contact-help-desk
      ref="contact-help-desk"
      titleModal="Solicitud Rechazada"
    />
    <modal-with-link ref="modal-with-link" />
  </div>
</template>

<style>
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import confirmHelpers from "@/helpers/confirmHelpers";
import KitsBusqueda from "@/components/KitsBusqueda";

import JsonCSV from "vue-json-csv";
Vue.component("downloadCsv", JsonCSV);
import PinValidation from '@/views/Pin/PinValidation';
import ContactHelpDesk from "@/views/ContactHelpDesk";
import ModalWithLink from "@/components/ModalWithLink.vue";

export default {
  components: { 
    KitsBusqueda,
    "pin-validation": PinValidation,
    "modal-with-link": ModalWithLink,
    "contact-help-desk": ContactHelpDesk
  },
  data() {
    return {
      recibidas: [],
      enviadas: [],
      verMasRecibidas: true,
      verMasEnviadas: true,
      modal: {
        show: false,
        item: {
          Image: "",
          OriginAccountName: "",
          OriginAccountMail: "",
          FormattedAmount: "",
          Reference: ""
        },
        MotivoAnulacion: "",
        mostrarRechazo: false
      },
      helpDeskInformation: {
        Message: "",
        Show: false,
        ShowInfo: false,
        WhatsappUrl: "",
        PhoneNumber: "",
        EmailAddress: "",
        EmailSubject: "",
        MessageBody: "",
        ShowUnlockMail: false,
        Name: "",
        ShowContactarSoporte: false,
      },
      usePaymentPin: false,
      showModalPinValidation: false
    };
  },
  methods: {
    cargarRecibidas() {
      let context = this;

      axiosHelpers.axiosGet(
        "MoneyRequest/MyMoneyRequestDestiny",
        { Skip: this.recibidas.length },
        this,
        function(data) {
          context.recibidas.push.apply(
            context.recibidas,
            data.ResponseVM.Items
          );

          if(data.ResponseVM.Items.length == 0){
            context.verMasRecibidas = false;
          }
        }
      );
    },
    cargarEnviadas() {
      let context = this;

      axiosHelpers.axiosGet(
        "MoneyRequest/MyMoneyRequestOrigin",
        { Skip: this.enviadas.length },
        this,
        function(data) {
          context.enviadas.push.apply(context.enviadas, data.ResponseVM.Items);
          if(data.ResponseVM.Items.length == 0){
            context.verMasEnviadas = false;
          }
        }
      );
    },
    itemClicked(item) {
      if (item.Pending) {
        this.modal.item = item;
        this.modal.show = true;
        this.modal.mostrarRechazo = false;
      }
    },
    aceptarSolicitud() {
      let context = this;

      axiosHelpers.axiosPost(
        "Account/AproveMoneyRequest",
        { RequestID: context.modal.item.EntityID },
        context,
        function(data) {
          if (data.ResponseVM.Success) {
            notificationHelpers.showSuccess(
              "Exito",
              "Se aprobó la solicitud correctamente",
              context
            );
            context.modal.show = false;
            context.recibidas = [];
            context.cargarRecibidas();
          }
        },
        function (message) {
          context.$refs["modal-with-link"].showModalWithParams(
            "Solicitud Rechazada",
            message,
            "verificacionidentidad",
            "Continuar"
          );                  
         },
        function () {
            context.helpDeskInformation.Show = true;
            context.helpDeskInformation.ShowContactarSoporte = true;
            context.helpDeskInformation.Message = 'Superaste tu límite de operación, comunicate con nosotros para validar el nivel de tu cuenta.';
            context.helpDeskInformation.EmailAddress =
              context.$store.getters.EmailAddress;
            context.helpDeskInformation.EmailSubject =
              context.$store.getters.EmailSubject;
            context.helpDeskInformation.MessageBody =
              context.$store.getters.MessageBody;
            context.helpDeskInformation.UrlWhatsapp =
              context.$store.getters.UrlWhatsapp;
            context.helpDeskInformation.PhoneNumber =
              context.$store.getters.PhoneNumber;
            context.$refs["contact-help-desk"].setHelpDeskInformation(
              context.helpDeskInformation
            );                     
         }
      );
    },
    confirmarAceptarSolicitud() {
      let context = this;

      confirmHelpers.showConfirm(
        "Está seguro que desea aceptar la solicitud?",
        context,
        function() {
          context.pinValidate();
        }
      );
    },
    rechazarSolicitud() {
      this.modal.mostrarRechazo = true;
    },
    confirmarRechazarSolicitud() {
      let context = this;
      if (this.modal.MotivoAnulacion == "") {
        notificationHelpers.showWarning(
          "Alerta",
          "Debe ingresar un motivo de anulación",
          this
        );
        return;
      }

      confirmHelpers.showConfirm(
        "Está seguro que desea rechazar la solicitud?",
        this,
        function() {
          axiosHelpers.axiosPost(
            "Account/RejectMoneyRequest",
            {
              RequestID: context.modal.item.EntityID,
              RejectReason: context.modal.MotivoAnulacion
            },
            context,
            function(data) {
              if (data.ResponseVM.Success) {
                notificationHelpers.showSuccess(
                  "Exito",
                  "Se rechazó la solicitud correctamente",
                  context
                );
                context.modal.MotivoAnulacion = "";
                context.modal.show = false;
                context.recibidas = [];
                context.cargarRecibidas();
              }
            }
          );
        }
      );
    },
    onValidPin(val) {
      if(val) {
        this.aceptarSolicitud();
      }
    },
    onLoadUsePaymentPin(val) {
      this.usePaymentPin = val;
    },
    pinValidate() {
      if(this.usePaymentPin) {
        this.showModalPinValidation = true;
      } else {
        this.aceptarSolicitud();
      }
    }
  },
  beforeMount: function() {
    this.cargarRecibidas();
    this.cargarEnviadas();
  }
};
</script>